import { configureStore, createSlice } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const savedLocationsSlice = createSlice({
  name: 'savedLocations',
  initialState: [],
  reducers: {
    addLocation: (state, action) => {
      state.push(action.payload);
    },
    removeLocation: (state, action) => {
      return state.filter((location, index) => index !== action.payload);
    },
  },
});

const apiKeySlice = createSlice({
  name: 'apiKey',
  initialState: '',
  reducers: {
    setApiKey: (state, action) => {
      return action.payload;
    },
  },
});

const rootReducer = combineReducers({
  savedLocations: savedLocationsSlice.reducer,
  apiKey: apiKeySlice.reducer,
});

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const { addLocation, removeLocation } = savedLocationsSlice.actions;
export const { setApiKey } = apiKeySlice.actions;

export const persistor = persistStore(store);
